import { gql } from "@apollo/client";

export const GridList = gql`
    query GridList ($search: SearchInput, $filter: GridListFilter, $pagination: Pagination){
        gridList(
            search: $search,
            filter: $filter
        ) {
            total
            grids(pagination: $pagination) {
                id
                title
            }
        }
    }
`;
